import React, { FC } from 'react'
import styled, { css, DefaultTheme } from 'styled-components'

import { imageLoadingCircle } from '@Globals/Style/mixins'

export interface ProgressProps {
  /**
   * parent must have position: relative
   */
  center?: boolean
  color?: 'grey' | 'primary' | 'white'
  size?: 'x-small' | 'small'
}

type StyledProps = ProgressProps & { theme: DefaultTheme }

const grey = ({ color, theme }: StyledProps) => {
  if (color === 'grey') {
    return css`
      border-left-color: ${theme.colors.grey};
      border-right-color: ${theme.colors.grey};
    `
  }
  return css``
}

const primary = ({ color, theme }: StyledProps) => {
  if (color === 'primary') {
    return css`
      border-left-color: ${theme.colors.primary};
      border-right-color: ${theme.colors.primary};
    `
  }
  return css``
}

const white = ({ color }: StyledProps) => {
  if (color === 'white') {
    return css`
      border-left-color: #fff;
      border-right-color: #fff;
    `
  }
  return css``
}

const centered = ({ center, size }: StyledProps) => {
  if (center && size === 'small') {
    return css`
      top: calc(50% - 13px);
      left: calc(50% - 13px);
    `
  }
  if (center && size === 'x-small') {
    return css`
      top: calc(50% - 9px);
      left: calc(50% - 9px);
    `
  }
  return css``
}

const StyledProgress = styled.div<ProgressProps>`
  ${({ size }) => (
    size === 'small'
      ? css`${imageLoadingCircle({ borderWidth: '3px', color: '#fff', size: '26px' })}`
      : css`${imageLoadingCircle({ borderWidth: '2px', color: '#fff', size: '18px' })}`
  )}
  ${grey}
  ${primary}
  ${white}
  ${centered}
`

export const Progress: FC<ProgressProps> = (
  {
    center = false,
    color = 'primary',
    size = 'small',
  }: ProgressProps,
) => (
  <StyledProgress center={center} color={color} size={size} />
  /* <div
    className={clsx(
      css.Progress,
      center && css.ProgressCenter,
      color === 'grey' && css.ProgressColorGrey,
      color === 'primary' && css.ProgressColorPrimary,
      color === 'white' && css.ProgressColorWhite,
      size === 'small' && css.ProgressSizeSmall,
      size === 'x-small' && css.ProgressSizeXSmall,
    )}
  /> */
)
